import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import Header from "@/components/Header";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const dest = location.state?.from || "/inicio";

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await login(email, password);
            navigate(dest, { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen relative grain">
            <Header />
            <main className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-16 pt-12 pb-24">
                <section className="hidden md:flex flex-col justify-center">
                    <div className="overline text-[#5C5C5C]">Bem-vindo de volta</div>
                    <h1 className="font-display font-light text-5xl mt-3 leading-tight">
                        Retome sua <span className="font-editorial italic text-holo">jornada</span>.
                    </h1>
                    <p className="font-body text-[#5C5C5C] mt-6 max-w-md">
                        Acesse sua conta para continuar de onde parou e receber novas práticas todas as semanas.
                    </p>
                </section>

                <section className="bg-white border border-black/5 rounded-3xl p-8 md:p-12">
                    <h2 className="font-display text-2xl tracking-tight">Entrar</h2>
                    <p className="font-body text-sm text-[#5C5C5C] mt-1">Use seu e-mail e senha cadastrados.</p>

                    <form onSubmit={submit} className="mt-8 space-y-5">
                        <div>
                            <label className="overline text-[#5C5C5C]">E-mail</label>
                            <input
                                data-testid="login-email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="imq-input mt-2"
                                placeholder="voce@email.com"
                            />
                        </div>
                        <div>
                            <label className="overline text-[#5C5C5C]">Senha</label>
                            <input
                                data-testid="login-password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="imq-input mt-2"
                                placeholder="••••••••"
                            />
                        </div>
                        {error && (
                            <div data-testid="login-error" className="text-sm text-red-600 font-body bg-red-50 border border-red-100 px-3 py-2 rounded-lg">{error}</div>
                        )}
                        <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
                            {loading ? "Entrando..." : "Entrar"}
                        </button>
                    </form>

                    <div className="mt-8 text-sm font-body text-[#5C5C5C]">
                        Novo por aqui?{" "}
                        <Link to="/cadastro" data-testid="login-to-register" className="text-[#1A1A1A] underline underline-offset-4">
                            Comece grátis por 7 dias
                        </Link>
                    </div>
                </section>
            </main>
        </div>
    );
}
